export const ModalHeader = () => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-sm transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:rotate-3 group">
        <img
          className="h-6 w-auto brightness-0 invert"
          src="/images/viLogoV.svg"
          alt="Vanishing Inc Logo"
        />
      </div>

      <div className="flex-1 min-w-0">
        <h3 className="text-lg font-semibold text-gray-900">Welcome back</h3>
        <p className="text-gray-500 text-sm">Sign in to your account</p>
      </div>
    </div>
  )
}
